import actionTypes from "actions/actionTypes"
import { ActionCreator } from "types/redux"

export const dragEnter: ActionCreator = () => ({
  type: actionTypes.DRAG_ENTER
})

export const dragLeave: ActionCreator = () => ({
  type: actionTypes.DRAG_LEAVE
})

export const resetDragState: ActionCreator = () => ({
  type: actionTypes.DRAG_RESET
})
